/**
 * Shared UI micro-components for the OzPol Transparent donations feature.
 */
import { fmt } from "../../utils/donationsUtils";

/** Custom tooltip for Recharts pie charts */
export function PieTip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const d = payload[0];
  return (
    <div style={{
      background: "#0F172A", color: "#fff", padding: "10px 14px",
      border: "2px solid #FFC82E", fontFamily: "Outfit, sans-serif", fontSize: 12,
    }}>
      <div style={{ fontWeight: 700, marginBottom: 2 }}>{d.name}</div>
      <div style={{ color: "#FFC82E", fontWeight: 800 }}>{fmt(d.value)}</div>
      <div style={{ color: "#94A3B8", fontSize: 11 }}>{d.payload?.pct}% of total declared</div>
    </div>
  );
}

/** Brutalist stat box */
export function Stat({ label, value, sub, highlight, isDark }) {
  return (
    <div style={{
      border: "2px solid #000", padding: "12px 14px",
      background: highlight ? "#FFC82E" : (isDark ? "#0F172A" : "#F9F7F2"),
      boxShadow: "3px 3px 0 #000", flex: 1, minWidth: 110,
    }}>
      <div style={{
        fontSize: 9, fontWeight: 800, letterSpacing: "0.07em",
        color: highlight ? "#333" : "#6B7280", marginBottom: 4,
      }}>
        {label}
      </div>
      <div style={{
        fontSize: 20, fontWeight: 900, fontFamily: "Outfit, sans-serif",
        color: highlight ? "#000" : (isDark ? "#F8FAFC" : "#0F172A"),
      }}>{value}</div>
      {sub && <div style={{ fontSize: 9, color: highlight ? "#555" : "#6B7280", marginTop: 2 }}>{sub}</div>}
    </div>
  );
}
